/* eslint-disable @typescript-eslint/ban-ts-comment */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-unsafe-return */
/* eslint-disable @typescript-eslint/no-unsafe-call */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
import React, { useEffect, useState } from 'react'
import { useForm, Controller } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import * as Yup from 'yup';
import { Autocomplete, FormHelperText, TextField } from '@mui/material';

import { DemoContainer } from '@mui/x-date-pickers/internals/demo';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment'
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import moment from 'moment';
import Box from '@mui/material/Box';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import { JobTypes, NameParser_ParseHint, ProjectTypes } from './data';
import GradientButton from '../MUICustomButton/GradientButton';
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import { NotificationManager } from 'react-notifications';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import { styled, Tooltip, tooltipClasses } from '@mui/material';
import type { TooltipProps } from '@mui/material';

const BootstrapTooltip = styled(({ className, ...props }: TooltipProps) => (
    <Tooltip
        {...props}
        arrow
        classes={{ popper: className }}
        placement="bottom"
    />
))(({ theme }) => ({
    [`& .${tooltipClasses.arrow}`]: {
        color: theme.palette.common.black,
    },
    [`& .${tooltipClasses.tooltip}`]: {
        backgroundColor: theme.palette.common.black,
    },
}));

interface RequestDetailsInputs {
    requestId: string;
    requestName: string;
    clientId: string;
    jobTypeId: string;
    projectName: string;
    projectTypeId: string;
    nameParser_ParseHint: number;
    mailableRating: string;
    emailSaleContractType: string;
    emailSaleExpirationDate: string | null;
    emailSaleRentalCount: string;
    emailSaleTierToAppend: number;
    suppress_Email_NotNull: boolean;
    suppress_Email_SameHLD: boolean;
    suppress_Phone_NotNull: boolean;
    suppress_Phone_SameHLD: boolean;
    suppress_Address_NotNull: boolean;
    suppress_Address_SameHLD: boolean;
}

interface RequestDataProps {
    "requestID": string;
    "requestName": string;
    "clientID": number;
    "dataAnalystUserID": number;
    "projectName": string;
    "projectTypeID": number;
    "jobTypeID": number;
    "source_NPI_FieldName": string;
    "source_FirstName_FieldName": string;
    "source_LastName_FieldName": string;
    "source_Address1_FieldName": string;
    "source_Address2_FieldName": string;
    "source_City_FieldName": string;
    "source_State_FieldName": string;
    "source_Zip_FieldName": string;
    "source_Phone_FieldName": string;
    "source_StateLicense_FieldName": string;
    "source_MENumber_FieldName": string;
    "source_DEANumber_FieldName": string;
    "provID_FieldName": string;
    "specID_FieldName": string;
    "nameParser_FullName_FieldName": string;
    "source_Email_FieldName": string;
    "source_Email2_FieldName": string;
    "nameParser_ParseHint": number;
    "suppress_Email_NotNull": number;
    "suppress_Email_SameHLD": number;
    "suppress_Phone_NotNull": number;
    "suppress_Phone_SameHLD": number;
    "suppress_Address_NotNull": number;
    "suppress_Address_SameHLD": number;
    "mailable_Rating": number;
    "emailSale_ContractType": string;
    "emailSale_ExpirationDate": string;
    "emailSale_RentalCount": number;
    "emailSale_TierToAppend": number;
    "userId": number;
}

interface PropsType {
    activeStep: number;
    onNextClick: (requestData: RequestDataProps) => void;
    selectedFiles: File[];
    requestData: RequestDataProps;
}


const validationSchema = Yup.object().shape({
    requestId: Yup.string().required("Please enter request id"),
    requestName: Yup.string().required("Please enter request name"),
    clientId: Yup.string().required("Please enter client id"),
    jobTypeId: Yup.string().required("Please select job type"),
    // projectName: Yup.string().required("Please enter project name"),
    projectTypeId: Yup.string().required("Please select project type"),
    emailSaleContractType: Yup.string().nullable()
        .when('projectTypeId', {
            // @ts-ignore
            is: (projectTypeId: number) => projectTypeId !== undefined && (parseInt(projectTypeId) === 2 || parseInt(projectTypeId) === 5),
            then: () => Yup.string().required("Please select contract type.")
        }),
    emailSaleExpirationDate: Yup.string().nullable()
        .when('emailSaleContractType', {
            is: (emailSaleContractType: string) => emailSaleContractType !== undefined && emailSaleContractType === 'L',
            then: () => Yup.string().required("Please enter expiration date.")
        }),
    emailSaleRentalCount: Yup.string()
        .when('emailSaleContractType', {
            is: (emailSaleContractType: string) => emailSaleContractType !== undefined && emailSaleContractType === 'R',
            then: () => Yup.string().required("Please enter rental count.")
        }),
    // nameParser_ParseHint: Yup.number().required("Please select NameParser_ParseHint"),
    // mailableRating: Yup.number().integer("Please enter valid number"),
    // emailSaleContractType: Yup.string().required("Please select EmailSale_ContractType"),
    // emailSaleExpirationDate: string;
    // emailSaleRentalCount: number | null;
    // emailSaleTierToAppend: number;
});

function RequestDetailsForm({ activeStep, onNextClick, selectedFiles, requestData }: PropsType): JSX.Element {

    

    const [hideFormFields, setHideFormFields] = useState<boolean>(true)

    useEffect(() => {
        console.log("requestData==x", requestData)
        // @ts-ignore
        if (requestData !== undefined && (parseInt(requestData.projectTypeID) === 2 || parseInt(requestData.projectTypeID) === 5)) {
            setHideFormFields(false)
        }
    }, [])
    const {
        control,
        handleSubmit,
        // reset,
        clearErrors,
        setValue,
        formState: { errors },
    } = useForm<RequestDetailsInputs>({
        //@ts-ignore
        resolver: yupResolver(validationSchema),
        mode: 'onSubmit',
        defaultValues: {
            requestId: requestData !== undefined ? requestData.requestID : "",
            requestName: requestData !== undefined ? requestData.requestName : "",
            // @ts-ignore
            clientId: requestData !== undefined ? requestData.clientID : "",
            // @ts-ignore
            projectTypeId: requestData !== undefined ? requestData.projectTypeID : "",
            // @ts-ignore
            jobTypeId: requestData !== undefined ? requestData.jobTypeID : "",
            // @ts-ignore
            emailSaleContractType: requestData !== undefined ? requestData.emailSale_ContractType : "",
            // @ts-ignore
            emailSaleExpirationDate: requestData !== undefined ? moment(requestData.emailSale_ExpirationDate) : moment(new Date()),
            // @ts-ignore
            emailSaleRentalCount: requestData !== undefined ? requestData.emailSale_RentalCount !== 0 ? requestData.emailSale_RentalCount : "" : "",
            // @ts-ignore
            nameParser_ParseHint: requestData !== undefined ? requestData.nameParser_ParseHint : 0,
            // @ts-ignore
            mailableRating: requestData !== undefined ? requestData.mailable_Rating : 400,
            // @ts-ignore
            suppress_Email_NotNull: requestData !== undefined ? parseInt(requestData.suppress_Email_NotNull) === 1 ? true : false : false,
            // @ts-ignore
            suppress_Email_SameHLD: requestData !== undefined ? parseInt(requestData.suppress_Email_SameHLD) === 1 ? true : false : false,
            // @ts-ignore
            suppress_Phone_NotNull: requestData !== undefined ? parseInt(requestData.suppress_Phone_NotNull) === 1 ? true : false : false,
            // @ts-ignore
            suppress_Phone_SameHLD: requestData !== undefined ? parseInt(requestData.suppress_Phone_SameHLD) === 1 ? true : false : false,
            // @ts-ignore
            suppress_Address_NotNull: requestData !== undefined ? parseInt(requestData.suppress_Address_NotNull) === 1 ? true : false : false,
            // @ts-ignore
            suppress_Address_SameHLD: requestData !== undefined ? parseInt(requestData.suppress_Address_SameHLD) === 1 ? true : false : false,
            emailSaleTierToAppend: requestData !== undefined ? requestData.emailSale_TierToAppend : 1,
        }
    });

    const minDate = moment('2000-01-01');

    const maxDate = moment('2050-12-31');

    const shouldDisableDate = (day: any): boolean => {
        return day.isBefore(minDate, 'day');
    };

    const onSubmit = async (data: RequestDetailsInputs): Promise<void> => {
        console.log(data)

        // @ts-ignore

        const userData = JSON.parse(localStorage.getItem("user"))
        if (selectedFiles.length > 0) {
            const requestData = {
                "dataAnalystUserID": userData.dataAnalystUserID,
                "requestID": data.requestId,
                "requestName": data.requestName,
                "clientID": data.clientId !== undefined ? data.clientId : 0,
                "jobTypeID": data.jobTypeId !== undefined ? data.jobTypeId : 0,
                "projectName": data.projectName !== undefined ? data.projectName : null,
                "projectTypeID": data.projectTypeId !== undefined ? data.projectTypeId : 0,
                "nameParser_ParseHint": data.nameParser_ParseHint !== undefined ? data.nameParser_ParseHint : 0,
                "source_NPI_FieldName": "",
                "source_FirstName_FieldName": "",
                "source_LastName_FieldName": "",
                "source_Address1_FieldName": "",
                "source_Address2_FieldName": "",
                "source_City_FieldName": "",
                "source_State_FieldName": "",
                "source_Zip_FieldName": "",
                "source_Phone_FieldName": "",
                "source_StateLicense_FieldName": "",
                "source_MENumber_FieldName": "",
                "source_DEANumber_FieldName": "",
                "provID_FieldName": "",
                "specID_FieldName": "",
                "nameParser_FullName_FieldName": "",
                "source_Email_FieldName": "",
                "source_Email2_FieldName": "",
                "suppress_Email_NotNull": data.suppress_Email_NotNull === true ? 1 : 0,
                "suppress_Email_SameHLD": data.suppress_Email_SameHLD === true ? 1 : 0,
                "suppress_Phone_NotNull": data.suppress_Phone_NotNull === true ? 1 : 0,
                "suppress_Phone_SameHLD": data.suppress_Phone_SameHLD === true ? 1 : 0,
                "suppress_Address_NotNull": data.suppress_Address_NotNull === true ? 1 : 0,
                "suppress_Address_SameHLD": data.suppress_Address_SameHLD === true ? 1 : 0,
                "mailable_Rating": data.mailableRating !== undefined ? data.mailableRating !== "" ? data.mailableRating : 0 : 0,
                "emailSale_ContractType": data.emailSaleContractType !== undefined ? data.emailSaleContractType : "",
                "emailSale_ExpirationDate": data.emailSaleExpirationDate !== null ? moment(data.emailSaleExpirationDate).format("YYYY-MM-DD") : moment(new Date()).format("YYYY-MM-DD"),
                "emailSale_RentalCount": data.emailSaleRentalCount !== undefined ? data.emailSaleRentalCount !== "" ? data.emailSaleRentalCount : 0 : 0,
                "emailSale_TierToAppend": data.emailSaleTierToAppend !== undefined ? data.emailSaleTierToAppend : 0,
                "userId": userData.id,
            }
            // @ts-ignore
            onNextClick(requestData)
        } else {
            NotificationManager.error("Please select file for mapping")
        }

    }

    const handleNext = (): void => {
        console.log(activeStep)
    }

    const getValueFromObject = (object: any, value: any): string => {
        if (value !== "") {
            const objWithValueOne = object.filter((obj: any) => parseInt(obj.value) === parseInt(value));
            return objWithValueOne.length > 0 ? objWithValueOne[0].label : ""
        } else {
            return ""
        }

    }

    const handleKeyDown = (e: any): void => {
        if (
            e.key === 'e' ||
            e.key === 'E' ||
            e.key === '+' ||
            e.key === '-' ||
            e.key === '.'
        ) {
            e.preventDefault();
        }
    };

    return (
        <React.Fragment>
            <form
                onSubmit={(e) => {
                    e.preventDefault();
                    void handleSubmit(onSubmit)(e);
                }}
            >
                <div className='grid gap-5 grid-cols-2'>
                    <div className='w-full relative'>
                        <div className="mb-[30px]">
                            <Controller
                                name="requestId"
                                control={control}
                                // defaultValue=""
                                render={({ field }) => (
                                    <TextField
                                        {...field}
                                        fullWidth
                                        label="Request Id*"
                                        autoComplete="off"
                                        // placeholder="Enter Request Id"
                                        // value={field.value}
                                        error={Boolean(errors.requestId)}
                                        helperText={errors.requestId?.message}
                                    />
                                )}
                            />
                        </div>
                    </div>
                    <div className='w-full relative'>
                        <div className="mb-[30px]">
                            <Controller
                                name="requestName"
                                control={control}
                                // defaultValue=""
                                render={({ field }) => (
                                    <TextField
                                        {...field}
                                        fullWidth
                                        label="Request name*"
                                        autoComplete="off"
                                        // placeholder="Enter request name"
                                        // value={field.value}
                                        error={Boolean(errors.requestName)}
                                        helperText={errors.requestName?.message}
                                    />
                                )}
                            />
                        </div>
                    </div>
                </div>

                <div className='grid gap-5 grid-cols-2'>
                    <div className='w-full relative'>
                        <div className="mb-[30px]">
                            <Controller
                                name="clientId"
                                control={control}
                                // defaultValue=""
                                render={({ field }) => (
                                    <TextField
                                        {...field}
                                        fullWidth
                                        label="Client Id*"
                                        autoComplete="off"
                                        // placeholder="Enter Client Id"
                                        // value={field.value}
                                        error={Boolean(errors.clientId)}
                                        helperText={errors.clientId?.message}
                                    />
                                )}
                            />
                        </div>
                    </div>
                    <div className='w-full relative'>
                        <div className="mb-[30px]">
                            <Controller
                                name="projectTypeId"
                                control={control}
                                // defaultValue=""
                                render={({ field }) => (
                                    <Box >
                                        <FormControl fullWidth>
                                            {/* @ts-ignore */}
                                            <Autocomplete
                                                {...field}
                                                disablePortal
                                                disableClearable
                                                id="combo-box-demo"
                                                popupIcon={<KeyboardArrowDownIcon />}
                                                // open={openAutocomplete}
                                                // onOpen={() => setOpenAutocomplete(true)}
                                                // onClose={() => setOpenAutocomplete(false)}
                                                // onFocus={() => setOpenAutocomplete(true)}
                                                // @ts-ignore
                                                value={getValueFromObject(ProjectTypes, field.value)}
                                                options={ProjectTypes}
                                                onChange={(event: any, newValue: any) => {
                                                    setValue("emailSaleContractType", "")
                                                    // @ts-ignore
                                                    setValue("emailSaleExpirationDate", moment(new Date()))
                                                    setValue("emailSaleRentalCount", "")
                                                    clearErrors('emailSaleRentalCount')
                                                    clearErrors('emailSaleExpirationDate')
                                                    if (newValue.label === "Order" || newValue.label === "Refresh Order") {
                                                        setHideFormFields(false)
                                                    } else {
                                                        setHideFormFields(true)
                                                    }
                                                    field.onChange(newValue.value)
                                                }}
                                                // sx={{ width: 300 }}
                                                renderInput={(params) => <TextField {...params} label="Project type*" error={Boolean(errors.projectTypeId)} />}
                                            />
                                            <FormHelperText sx={{ color: '#ED4B52', marginLeft: '0px' }}>{errors.projectTypeId?.message}</FormHelperText>
                                        </FormControl>
                                    </Box>
                                )}
                            />

                        </div>
                    </div>
                </div>

                <div className='grid gap-5 grid-cols-2'>
                    <div className='w-full relative'>
                        <div className="mb-[30px]">
                            <Controller
                                name="jobTypeId"
                                control={control}
                                // defaultValue=""
                                render={({ field }) => (
                                    <FormControl fullWidth>
                                        {/* @ts-ignore */}
                                        <Autocomplete
                                            {...field}
                                            disablePortal
                                            disableClearable
                                            id="combo-box-demo"
                                            popupIcon={<KeyboardArrowDownIcon />}
                                            // open={openAutocomplete}
                                            // onOpen={() => setOpenAutocomplete(true)}
                                            // onClose={() => setOpenAutocomplete(false)}
                                            // onFocus={() => setOpenAutocomplete(true)}
                                            // @ts-ignore
                                            value={getValueFromObject(JobTypes, field.value)}
                                            options={JobTypes}
                                            onChange={(event: any, newValue: any) => {
                                                field.onChange(newValue.value)
                                            }}
                                            // sx={{ width: 300 }}
                                            renderInput={(params) => <TextField {...params} label="Job type*" error={Boolean(errors.jobTypeId)} />}
                                        />
                                        <FormHelperText sx={{ color: '#ED4B52', marginLeft: '0px' }}>{errors.jobTypeId?.message}</FormHelperText>
                                    </FormControl>
                                )}
                            />
                        </div>
                    </div>
                    <div className='w-full relative'>
                        {
                            !hideFormFields &&
                            <div className="mb-[30px]">
                                <Controller
                                    name="emailSaleContractType"
                                    control={control}
                                    // defaultValue=""
                                    render={({ field }) => (
                                        <Box >
                                            <FormControl fullWidth>
                                                <InputLabel id="demo-simple-select-label">Contract type*</InputLabel>
                                                <Select
                                                    {...field}
                                                    labelId="demo-simple-select-label"
                                                    id="demo-simple-select"
                                                    // value={age}
                                                    label="Contract type*"
                                                    MenuProps={{ className: 'custom-dropdown' }}
                                                    IconComponent={KeyboardArrowDownIcon}
                                                    onChange={(e: any) => {
                                                        if (e.target.value === 'L') {
                                                            clearErrors('emailSaleRentalCount')
                                                        } else {
                                                            clearErrors('emailSaleExpirationDate')
                                                        }
                                                        // @ts-ignore
                                                        setValue("emailSaleExpirationDate", moment(new Date()))
                                                        setValue("emailSaleRentalCount", "")
                                                        field.onChange(e.target.value)
                                                    }}
                                                    error={Boolean(errors.emailSaleContractType)}
                                                // helperText={errors.jobTypeId?.message}
                                                >
                                                    <MenuItem value="L">License</MenuItem>
                                                    <MenuItem value="R">Rental</MenuItem>
                                                </Select>
                                                <FormHelperText sx={{ color: '#ED4B52', marginLeft: '0px' }}>{errors.emailSaleContractType?.message}</FormHelperText>
                                            </FormControl>
                                        </Box>
                                    )}
                                />

                            </div>
                        }
                    </div>
                </div>

                <div className='grid gap-5 grid-cols-2'>
                    <div className='w-full relative'>
                        {
                            !hideFormFields &&
                            <div className="mb-[30px]">

                                <Controller
                                    name="emailSaleExpirationDate"
                                    control={control}
                                    // defaultValue=""
                                    render={({ field }) => (
                                        <LocalizationProvider dateAdapter={AdapterMoment}>
                                            <DemoContainer components={['DatePicker']}>
                                                <DatePicker
                                                    label="Expiration date"
                                                    // @ts-ignore
                                                    value={field.value}
                                                    onChange={(newValue) => field.onChange(newValue)}
                                                    shouldDisableDate={shouldDisableDate}
                                                    minDate={minDate}
                                                    maxDate={maxDate}
                                                    slotProps={{
                                                        textField: () => ({
                                                            error: Boolean(errors.emailSaleExpirationDate),
                                                            helperText: errors.emailSaleExpirationDate?.message
                                                        }),
                                                    }
                                                    }
                                                />
                                            </DemoContainer>
                                        </LocalizationProvider>

                                    )}
                                />

                            </div>
                        }
                    </div>
                    <div className='w-full relative'>
                        {
                            !hideFormFields &&
                            <div className="mb-[30px]">

                                <Controller
                                    name="emailSaleRentalCount"
                                    control={control}
                                    // defaultValue={400}
                                    render={({ field }) => (
                                        <TextField
                                            {...field}
                                            type='number'
                                            fullWidth
                                            label="Rental count"
                                            autoComplete="off"
                                            // placeholder="Enter Rental Count"
                                            InputProps={{
                                                inputProps: { min: 0 }
                                            }}
                                            // value={field.value}
                                            error={Boolean(errors.emailSaleRentalCount)}
                                            helperText={errors.emailSaleRentalCount?.message}
                                            onKeyDown={handleKeyDown}
                                        />
                                    )}
                                />

                            </div>
                        }
                    </div>
                </div>

                <hr style={{color: "#D9D9D9"}} />
                <h3 className='text-lg text-muted font-semibold mb-2 mt-[30px]'>Optional Fields</h3>

                <div className='grid gap-5 grid-cols-2'>
                    <div className='w-full relative'>
                        <div className="mb-[30px]">
                            <Controller
                                name="nameParser_ParseHint"
                                control={control}
                                // defaultValue=""
                                render={({ field }) => (
                                    <Box >
                                        <FormControl fullWidth>
                                            {/* @ts-ignore */}
                                            <Autocomplete
                                                {...field}
                                                disablePortal
                                                disableClearable
                                                id="combo-box-demo"
                                                popupIcon={<KeyboardArrowDownIcon />}
                                                // open={openAutocomplete}
                                                // onOpen={() => setOpenAutocomplete(true)}
                                                // onClose={() => setOpenAutocomplete(false)}
                                                // onFocus={() => setOpenAutocomplete(true)}
                                                // @ts-ignore
                                                value={getValueFromObject(NameParser_ParseHint, field.value)}
                                                options={NameParser_ParseHint}
                                                onChange={(event: any, newValue: any) => {
                                                    field.onChange(newValue.value)
                                                }}
                                                // sx={{ width: 300 }}
                                                renderInput={(params) => <TextField {...params} label="Name parse hint" error={Boolean(errors.nameParser_ParseHint)} />}
                                            />
                                            <FormHelperText sx={{ color: '#ED4B52', marginLeft: '0px' }}>{errors.nameParser_ParseHint?.message}</FormHelperText>
                                        </FormControl>
                                    </Box>
                                )}
                            />
                        </div>
                    </div>
                    <div className='w-full relative'>
                        <div className="mb-[30px]">
                            <Controller
                                name="mailableRating"
                                control={control}
                                defaultValue="400"
                                render={({ field }) => (
                                    <TextField
                                        {...field}
                                        fullWidth
                                        label="Mailable rating"
                                        type='number'
                                        autoComplete="off"
                                        // placeholder="Enter Mailable Rating"
                                        // value={field.value}
                                        error={Boolean(errors.mailableRating)}
                                        helperText={errors.mailableRating?.message}
                                        onKeyDown={handleKeyDown}
                                    />
                                )}
                            />
                        </div>
                    </div>
                </div>
                <div className='grid gap-5 grid-cols-2'>
                    <div className='w-full relative'>
                        <div className="mb-[30px]">
                            <Controller
                                name="emailSaleTierToAppend"
                                control={control}
                                // defaultValue=""
                                render={({ field }) => (
                                    <Box >
                                        <FormControl fullWidth>
                                            <InputLabel id="demo-simple-select-label">Email tier to append</InputLabel>
                                            <Select
                                                {...field}
                                                labelId="demo-simple-select-label"
                                                id="demo-simple-select"
                                                // value={age}
                                                label="Email Tier to Append"
                                                MenuProps={{ className: 'custom-dropdown' }}
                                                IconComponent={KeyboardArrowDownIcon}
                                                // onChange={handleChange}
                                                error={Boolean(errors.emailSaleTierToAppend)}
                                            // helperText={errors.jobTypeId?.message}
                                            >
                                                <MenuItem value="1">Tier 1</MenuItem>
                                                <MenuItem value="2">Tier 2</MenuItem>
                                                <MenuItem value="3">Tier 3</MenuItem>
                                                <MenuItem value="4">Tier 4</MenuItem>
                                            </Select>
                                            <FormHelperText sx={{ color: '#ED4B52', marginLeft: '0px' }}>{errors.emailSaleTierToAppend?.message}</FormHelperText>
                                        </FormControl>
                                    </Box>
                                )}
                            />
                        </div>
                    </div>
                    <div className='w-full relative'>
                        <div className="mb-[30px]">

                        </div>
                    </div>
                </div>

                <hr style={{color: "#D9D9D9"}} />
                <h3 className='text-lg text-muted font-semibold font-semibold mb-2 mt-[30px]'>Suppress</h3>

                <div className='grid gap-5 grid-cols-3'>
                    <div className='w-full relative'>
                        <div className="mb-[30px]">
                            <Controller
                                name="suppress_Email_NotNull"
                                control={control}
                                // defaultValue={400}
                                render={({ field }) => (
                                    <div className="form-control">
                                        <label className={`cursor-pointer flex items-center`}>
                                            {/* @ts-ignore */}
                                            <input {...field} type="checkbox" className="checkbox" checked={field.value === true ? true : false} />
                                            <BootstrapTooltip title="Records with null email will be suppressed"><span className="text-muted text-14 font-normal">Null Email</span></BootstrapTooltip>

                                        </label>
                                    </div>
                                )}
                            />
                        </div>
                    </div>
                    <div className='w-full relative'>
                        <div className="mb-[30px]">
                            <Controller
                                name="suppress_Phone_NotNull"
                                control={control}
                                // defaultValue={400}
                                render={({ field }) => (
                                    <div className="form-control">
                                        <label className={`cursor-pointer flex items-center`}>
                                            {/* @ts-ignore */}
                                            <input {...field} type="checkbox" className="checkbox" checked={field.value === true ? true : false} />
                                            <BootstrapTooltip title="Records with null phone will be suppressed"><span className="text-muted text-14 font-normal">Null Phone</span></BootstrapTooltip>

                                        </label>
                                    </div>
                                )}
                            />
                        </div>
                    </div>
                    <div className='w-full relative'>
                        <div className="mb-[30px]">
                            <Controller
                                name="suppress_Address_NotNull"
                                control={control}
                                // defaultValue={400}
                                render={({ field }) => (
                                    <div className="form-control">
                                        <label className={`cursor-pointer flex items-center`}>
                                            {/* @ts-ignore */}
                                            <input {...field} type="checkbox" className="checkbox" checked={field.value === true ? true : false} />
                                            <BootstrapTooltip title="Records with null address will be suppressed"><span className="text-muted text-14 font-normal">Null Address</span></BootstrapTooltip>

                                        </label>
                                    </div>
                                )}
                            />
                        </div>
                    </div>
                </div>
                <div className='grid gap-5 grid-cols-3'>
                    <div className='w-full relative'>
                        <div className="mb-[30px]">
                            <Controller
                                name="suppress_Email_SameHLD"
                                control={control}
                                // defaultValue={400}
                                render={({ field }) => (
                                    <div className="form-control">
                                        <label className={`cursor-pointer flex items-center`}>
                                            {/* @ts-ignore */}
                                            <input {...field} type="checkbox" className="checkbox" checked={field.value === true ? true : false} />
                                            <BootstrapTooltip title="Records with same HLD email will be suppressed"><span className="text-muted text-14 font-normal">HLD Email</span></BootstrapTooltip>

                                        </label>
                                    </div>
                                )}
                            />
                        </div>
                    </div>
                    <div className='w-full relative'>
                        <div className="mb-[30px]">
                            <Controller
                                name="suppress_Phone_SameHLD"
                                control={control}
                                // defaultValue={400}
                                render={({ field }) => (
                                    <div className="form-control">
                                        <label className={`cursor-pointer flex items-center`}>
                                            {/* @ts-ignore */}
                                            <input {...field} type="checkbox" className="checkbox" checked={field.value === true ? true : false} />
                                            <BootstrapTooltip title="Records with same HLD phone will be suppressed"><span className="text-muted text-14 font-normal">HLD Phone</span></BootstrapTooltip>

                                        </label>
                                    </div>
                                )}
                            />
                        </div>
                    </div>
                    <div className='w-full relative'>
                        <div className="mb-[30px]">
                            <Controller
                                name="suppress_Address_SameHLD"
                                control={control}
                                // defaultValue={400}
                                render={({ field }) => (
                                    <div className="form-control">
                                        <label className={`cursor-pointer flex items-center`}>
                                            {/* @ts-ignore */}
                                            <input {...field} type="checkbox" className="checkbox" checked={field.value === true ? true : false} />
                                            <BootstrapTooltip title="Records with same HLD address will be suppressed"><span className="text-muted text-14 font-normal">HLD Address</span></BootstrapTooltip>

                                        </label>
                                    </div>
                                )}
                            />
                        </div>
                    </div>
                </div>
                <hr style={{color: "#D9D9D9"}} />
                <Box sx={{ display: 'flex', flexDirection: 'row', pt: 2 }}>

                    {/* <OutlineButton onClick={handleBack} color='gray'>
                                    Back
                                </OutlineButton> */}
                    <Box sx={{ flex: '1 1 auto' }} />

                    <GradientButton type='submit' onClick={handleNext} color='red' >
                        Next
                    </GradientButton>
                </Box>
            </form>
        </React.Fragment>
    )
}

export default RequestDetailsForm